<p-toast position="top-right"></p-toast>

<div class="user-container">
  <!-- Buttons Section -->
  <div class="button-group">
    <p-button
      label="{{ 'USER_PAGE.BUTTONS.ALL' | translate }}"
      [class.active]="activeFilter === ''"
      (click)="onFilterChange('')"
    ></p-button>
    <p-button
      label="{{ 'USER_PAGE.BUTTONS.CALLERS' | translate }}"
      [class.active]="activeFilter === userTypeConstants.CALLER"
      (click)="onFilterChange(userTypeConstants.CALLER)"
    ></p-button>
    <p-button
      label="{{ 'USER_PAGE.BUTTONS.TALKING_BUDDIES' | translate }}"
      [class.active]="activeFilter === userTypeConstants.TALKING_BUDDY"
      (click)="onFilterChange(userTypeConstants.TALKING_BUDDY)"
    ></p-button>
    <p-button
      label="{{ 'USER_PAGE.BUTTONS.EXPORT' | translate }}"
      icon="pi pi-download"
      class="p-button-primary export-button"
      (click)="exportExcel()"
    ></p-button>
  </div>

  <!-- Search Filters -->
  <div class="search-filters">
    <div class="filter-item">
      <label for="nickname" class="filter-label">{{
        'USER_PAGE.FILTER_LABELS.NICKNAME' | translate
      }}</label>
      <input
        type="text"
        pInputText
        placeholder="{{ 'USER_PAGE.PLACEHOLDERS.ENTER_NICKNAME' | translate }}"
        class="filter-field"
        id="nickname"
        [(ngModel)]="filters.nickName"
        (input)="onFilterChange(this.activeFilter)"
      />
    </div>
    <div class="filter-item">
      <label for="username" class="filter-label">{{
        'USER_PAGE.FILTER_LABELS.NAME' | translate
      }}</label>
      <input
        type="text"
        pInputText
        placeholder="{{ 'USER_PAGE.PLACEHOLDERS.ENTER_USER_NAME' | translate }}"
        class="filter-field"
        id="username"
        [(ngModel)]="filters.firstName"
        (input)="onFilterChange(this.activeFilter)"
      />
    </div>
    <div class="filter-item">
      <label for="mobileNumber" class="filter-label">{{
        'USER_PAGE.FILTER_LABELS.MOBILE_NUMBER' | translate
      }}</label>
      <input
        type="text"
        pInputText
        placeholder="{{ 'USER_PAGE.PLACEHOLDERS.ENTER_USER_MOBILE_NUMBER' | translate }}"
        class="filter-field"
        id="mobileNumber"
        [(ngModel)]="filters.phoneNumber"
        (input)="onFilterChange(this.activeFilter)"
      />
    </div>
    <div class="filter-item country-filter">
      <label for="countryId" class="filter-label">{{
        'USER_PAGE.FILTER_LABELS.COUNTRY' | translate
      }}</label>
      <p-dropdown
        [options]="countryIds"
        [(ngModel)]="filters.countryId"
        id="countryId"
        optionLabel="countryName"
        placeholder="{{ 'USER_PAGE.PLACEHOLDERS.SELECT_COUNTRY' | translate }}"
        (ngModelChange)="onFilterChange(this.activeFilter)"
      ></p-dropdown>
    </div>
    <div class="filter-item">
      <label for="regionId" class="filter-label">{{
        'USER_PAGE.FILTER_LABELS.STATE' | translate
      }}</label>
      <p-dropdown
        [options]="regionIds"
        [(ngModel)]="filters.regionId"
        id="regionId"
        optionLabel="regionName"
        placeholder="{{ 'USER_PAGE.PLACEHOLDERS.SELECT_STATE' | translate }}"
        (ngModelChange)="onFilterChange(this.activeFilter)"
      ></p-dropdown>
    </div>
    <div class="status-filters filter-item">
      <label for="status" class="filter-label">
        {{ 'USER_PAGE.FILTER_LABELS.STATUS' | translate }}
      </label>
      <p-dropdown
        [options]="statusOptions"
        [(ngModel)]="filters.status"
        id="status"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'USER_PAGE.PLACEHOLDERS.SELECT_STATUS' | translate }}"
        (ngModelChange)="onFilterChange(this.activeFilter)"
      >
      </p-dropdown>
    </div>

    <div class="filter-item">
      <label for="fromToDate" class="filter-label">{{
        'USER_PAGE.FILTER_LABELS.FROM_TO_DATE' | translate
      }}</label>
      <p-calendar
        id="fromToDate"
        [(ngModel)]="filters.dateRange"
        selectionMode="range"
        [showButtonBar]="true"
        [readonlyInput]="true"
        placeholder="{{ 'USER_PAGE.PLACEHOLDERS.SELECT_DATE_RANGE' | translate }}"
        dateFormat="dd-M-yy"
        (click)="onCalendarOpen()"
        (ngModelChange)="onFilterChange(this.activeFilter)"
      >
      </p-calendar>
    </div>
    <div class="filter-item" *ngIf="activeFilter === userTypeConstants.TALKING_BUDDY">
      <label for="paymentProfile" class="filter-label">
        {{ 'USER_PAGE.FILTER_LABELS.PAYMENT_PROFILE' | translate }}
      </label>
      <p-dropdown
        [options]="paymentProfiles"
        [(ngModel)]="filters.paymentProfile"
        id="paymentProfile"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'USER_PAGE.PLACEHOLDERS.SELECT_PAYMENT_PROFILE' | translate }}"
        (ngModelChange)="onFilterChange(this.activeFilter)"
      ></p-dropdown>
    </div>
    <div class="filter-item">
      <a class="reset-link text-primary" (click)="onResetFilters()">
        {{ 'USER_PAGE.BUTTONS.RESET' | translate }}
      </a>
    </div>
  </div>

  <!-- Data Table -->
  <p-table
    [value]="userItems.length !== 0 ? userItems : noDataRow"
    [paginator]="userItems.length !== 0 ? true : false"
    [rows]="rows"
    [first]="first"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onPage)="pageChange($event)"
    (onSort)="sortChange($event)"
    [rowsPerPageOptions]="tableParams.ROW_PER_PAGE"
    sortField="CreatedOn"
    [sortOrder]="-1"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Nickname">
          {{ 'USER_PAGE.USERS_TABLE.NICKNAME' | translate }}
          <p-sortIcon field="Nickname"></p-sortIcon>
        </th>
        <th pSortableColumn="FirstName">
          {{ 'USER_PAGE.USERS_TABLE.NAME' | translate }}
          <p-sortIcon field="FirstName"></p-sortIcon>
        </th>
        <th pSortableColumn="Gender">
          {{ 'USER_PAGE.USERS_TABLE.GENDER' | translate }}
          <p-sortIcon field="Gender"></p-sortIcon>
        </th>
        <th pSortableColumn="PhoneNumber">
          {{ 'USER_PAGE.USERS_TABLE.MOBILE_NUMBER' | translate }}
          <p-sortIcon field="PhoneNumber"></p-sortIcon>
        </th>
        <th pSortableColumn="Email">
          {{ 'USER_PAGE.USERS_TABLE.EMAIL_ADDRESS' | translate }}
          <p-sortIcon field="Email"></p-sortIcon>
        </th>
        <th pSortableColumn="CreatedOn">
          {{ 'USER_PAGE.USERS_TABLE.CREATED_ON' | translate }}
          <p-sortIcon field="CreatedOn"></p-sortIcon>
        </th>
        <th>
          {{ 'USER_PAGE.USERS_TABLE.STATUS' | translate }}
        </th>
        <th *ngIf="activeFilter === userTypeConstants.TALKING_BUDDY">
          {{ 'USER_PAGE.USERS_TABLE.PAYMENT_PROFILE' | translate }}
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
      <tr *ngIf="userItems?.length !== 0" (click)="goToUserDetailsPage(user)" class="user-row">
        <td>{{ user.nickname }}</td>
        <td>{{ formatFullName(user) }}</td>
        <td>{{ user.gender }}</td>
        <td>{{ user.phoneNumber }}</td>
        <td>{{ user.email }}</td>
        <td>
          {{
            user?.createdOn ? (getConvertedDate(user?.createdOn || '') | date: 'dd-MMM-YYYY') : ''
          }}
        </td>
        <td (click)="$event.stopPropagation()">
          <button
            pButton
            size="small"
            [label]="
              user.isBlocked
                ? ('USER_PAGE.FILTER_LABELS.BLOCKED' | translate)
                : ('USER_PAGE.FILTER_LABELS.ACTIVE' | translate)
            "
            [class]="user.isBlocked ? 'p-button-danger' : 'p-button-secondary'"
            (click)="updateBlockStatus(user)"
            class="action-button"
          ></button>
        </td>

        <td *ngIf="activeFilter === userTypeConstants.TALKING_BUDDY">
          <p-tag
            [value]="user.accountKycStatus"
            [severity]="user.accountKycStatus === 'Completed' ? 'success' : 'warning'"
            [styleClass]="
              'outlined-tag ' + (user.accountKycStatus === 'Completed' ? 'success' : 'warning')
            "
          >
          </p-tag>
        </td>
        <td class="icon-column">
          <div class="avatar-wrapper">
            <img
              class="user-img"
              [src]="user.avatar ? baseApiUrl + user.avatar : 'assets/icons/icon-profile.png'"
              title="icon-person"
              [alt]="user.firstName"
            />

            <!-- Availability Dot -->
            <span class="availability-dot" *ngIf="user.isAvailability"></span>

            <!-- Talking Buddy Badge -->
            <span class="tb-badge" *ngIf="user.userType === userTypeConstants.TALKING_BUDDY">
              <img
                class="table-avatar-tb-logo"
                src="assets/icons/tb-logo.svg"
                alt="Talking Buddy Badge"
              />
            </span>
          </div>

          <!-- Chevron Icon -->
          <i
            class="fa fa-chevron-right"
            [ngClass]="{
              'with-tb-i': user.userType === userTypeConstants.TALKING_BUDDY,
              'with-caller-i': user.userType !== userTypeConstants.TALKING_BUDDY,
            }"
            aria-hidden="true"
          ></i>
        </td>
      </tr>
      <tr *ngIf="userItems?.length === 0">
        <td colspan="6" class="no-data-available">
          {{ 'COMMON.NO_AVAILABLE' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
